import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, share, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { UnSyncedEdgesActions } from '@states/unsynced-edges/unsynced-edges.action-types';
import { SyncQueueService } from '../../services/sync-queue.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class UnSyncedEdgesEffects {
  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    private syncQueueService: SyncQueueService,
    private translateService: TranslateService,
  ) {}

  getUnSyncedEdges$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnSyncedEdgesActions.getUnSyncedEdges),
      switchMap(({ filters }) =>
        this.syncQueueService.getAllUnSyncedEdgesCommands(filters).pipe(
          map((edges) => UnSyncedEdgesActions.getUnSyncedEdgesSuccess({ edges })),
          catchError((error) => {
            console.error('Error loading unsynced edges:', error);
            return [UnSyncedEdgesActions.getUnSyncedEdgesFail({ error })];
          }),
        ),
      ),
      share(),
    ),
  );

  getUnSyncedEdgesSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnSyncedEdgesActions.getUnSyncedEdgesSuccess),
      map(() => UnSyncedEdgesActions.setInitialLoader({ loading: false })),
    ),
  );

  getUnSyncedEdgesFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnSyncedEdgesActions.getUnSyncedEdgesFail),
      map(() => UnSyncedEdgesActions.setInitialLoader({ loading: false })),
    ),
  );
} 